export default __webpack_public_path__ + "static/media/letter-template.cdf7f063.docx";